module.exports = __webpack_public_path__ + "static/media/diners.17bdb8b2.svg";